var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.023,
    viewBox: "0 0 15 15.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6630",
    "data-name": "Group 6630",
    transform: "translate(6413 9387)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 15,
    height: 15,
    transform: "translate(-6413 -9387)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Delete_Icon",
    "data-name": "Delete Icon",
    transform: "translate(-6410.328 -9387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M589.956-23.52h-5.027l-1.395-9.834h9.745",
    transform: "translate(-583.24 38.043)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M588.314-33.354l-1.322,9.834h-3.457",
    transform: "translate(-578.273 38.043)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M586.679-30.716v5.395",
    transform: "translate(-583.2 37.625)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M586.679-30.716v5.395",
    transform: "translate(-579.906 37.625)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_254",
    "data-name": "Path 254",
    transform: "translate(2.1)",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.895,0H5.367a.864.864,0,0,1,.895.831V2.492a.864.864,0,0,1-.895.831H.895A.864.864,0,0,1,0,2.492V.831A.864.864,0,0,1,.895,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.000004768371582 0.999997615814209 L 1.000004768371582 2.322217702865601 L 5.26164436340332 2.322217702865601 L 5.26164436340332 0.999997615814209 L 1.000004768371582 0.999997615814209 M 0.8945245742797852 -2.384185791015625e-06 L 5.367124557495117 -2.384185791015625e-06 C 5.861154556274414 -2.384185791015625e-06 6.26164436340332 0.3718476295471191 6.26164436340332 0.8305575847625732 L 6.26164436340332 2.491657733917236 C 6.26164436340332 2.95036768913269 5.861154556274414 3.322217702865601 5.367124557495117 3.322217702865601 L 0.8945245742797852 3.322217702865601 C 0.4004945755004883 3.322217702865601 4.76837158203125e-06 2.95036768913269 4.76837158203125e-06 2.491657733917236 L 4.76837158203125e-06 0.8305575847625732 C 4.76837158203125e-06 0.3718476295471191 0.4004945755004883 -2.384185791015625e-06 0.8945245742797852 -2.384185791015625e-06 Z",
    stroke: "none",
    fill: "red"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M583.132-35.525h10.252",
    transform: "translate(-583.132 38.411)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete Icon.5b6c973009a13a5085b340bb88add342.svg";
export { ForwardRef as ReactComponent };